import React from 'react';
import { Rect } from 'react-konva';
import './loadingStyle.scss';
import { Coordinates, Dimensions } from 'constants/';

interface Props {
  dimensions: Dimensions;
  coordinates: Coordinates;
  fill?: string;
  cornerRadius?: number;
}

const SkeletonLoading = (props: Props) => {
  const { dimensions, coordinates, fill = 'lightgray', cornerRadius = 5 } = props;

  return (
    <Rect
      id='canvas-loading-rect'
      {...dimensions}
      {...coordinates}
      fill={fill}
      cornerRadius={cornerRadius}
      className="shimmer"
    />
  );
};

export default SkeletonLoading;
